import { PaymentStatusMessageParams } from './paymentStatusMessage';

export const AZERICARD_GATEWAY = 'azericard';
export const PAYMENT_AZERICARD_PENDING_KEY = 'paymentAzericardPending';

export const markAzericardPaymentPending = () => {
  if (typeof window === 'undefined') return;

  window.localStorage.setItem(PAYMENT_AZERICARD_PENDING_KEY, '1');
};

export const clearAzericardPaymentPending = () => {
  if (typeof window === 'undefined') return;

  window.localStorage.removeItem(PAYMENT_AZERICARD_PENDING_KEY);
};

export const isAzericardPaymentPending = () => {
  if (typeof window === 'undefined') return false;

  return window.localStorage.getItem(PAYMENT_AZERICARD_PENDING_KEY) === '1';
};

export const isAzericardPaymentMethod = (paymentMethodId?: string | null) =>
  paymentMethodId === AZERICARD_GATEWAY;

export const enrichPaymentStatusParams = (
  params: PaymentStatusMessageParams
): PaymentStatusMessageParams => {
  if (params.gateway === AZERICARD_GATEWAY) {
    return params;
  }

  if (isAzericardPaymentPending()) {
    return { ...params, gateway: AZERICARD_GATEWAY };
  }

  return params;
};

export const isAzericardPaymentStatus = (
  params: PaymentStatusMessageParams
): boolean => params.gateway === AZERICARD_GATEWAY;
